import script from "./ToastsContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToastsContainer.vue?vue&type=script&lang=ts&setup=true"

import "./ToastsContainer.vue?vue&type=style&index=0&id=65e945d1&lang=scss"

const __exports__ = script;

export default __exports__